// eslint-disable-next-line banned-modules
'use strict';

import './style.less';
import Widget from '@/widgets/base.widget';
import template from './template.ejs';
import suggestionTemplate from './suggestion.ejs';
import validationTemplate from '@/widgets/validationErrorsTemplate.ejs';
import 'corejs-typeahead/dist/typeahead.jquery';
import BaseCollection from '@/classes/base.collection';
import BaseModel from '@/classes/base.model';

const AutocompleteModel = BaseModel.extend({
	idAttribute: 'uid',
});

const AutocompleteCollection = BaseCollection.extend({
	model: AutocompleteModel,
});

const Autocomplete = Widget.extend({

	validationTemplate,

	template,

	viewName: 'b-autocomplete',

	events: {
		'click .b-input__remove': 'removeItem',
	},

	initialize(options) {
		this.options = options;
		this.options.label = this.options.label || '';
		this.options.placeholder = this.options.placeholder || '';
		this.options.deletableField = (this.options.deletableField === true);
		this.options.values = Autocomplete.getStoreCollection(options.values).toJSON();
		this.options.removable = options.removable;
		this.options.setPropertyOnChange = [true, 'true'].includes(options.setPropertyOnChange);
		this.render();

		this.$typeahead = this.$('.b-autocomplete__value');
		this.$typeahead.typeahead({
			hint: false,
			highlight: false,
			minLength: 0,
			limit: 1,
			classNames: {
				menu: 'b-autocomplete__items',
				wrapper: 'b-autocomplete__wrapper',
				input: 'b-autocomplete__input',
				hint: 'b-autocomplete__hint',
				dataset: 'b-autocomplete__dataset',
				suggestion: 'b-autocomplete__item',
				selectable: 'b-autocomplete__selectable',
				empty: 'b-autocomplete__empty',
				open: 'b-autocomplete__open',
				cursor: 'b-autocomplete__cursor',
				highlight: 'b-autocomplete__highlight',
			},
		}, {
			limit: 100,
			name: 'autocomplete',
			source: (q, cb) => {
				let values = this.options.values;
				if (_.isFunction(this.options.formatter)) {
					values = this.options.formatter.call(this, values);
				}
				cb(values.reduce((result, item) => {
					if (item.caption.toUpperCase().includes(q.toUpperCase())) result.push(item);
					return result;
				}, []));
			},
			display: (item) => `${item.caption}`,
			templates: {
				suggestion: suggestionTemplate,
			},
		});
	},

	disable(disabled) {
		this.disabled = disabled;
		this.$el.find('.b-autocomplete__input').attr('disabled', disabled);
	},

	applyBinding(model) {
		this.$typeahead.on('typeahead:change', (ev, suggestion) => {
			if (suggestion.replace(/\s/g, '').length === 0) {
				this.model.set(this.options.bindingProperty, null);
			} else {
				if (this.options.setPropertyOnChange) {
					this.model.set(this.options.bindingProperty, suggestion);
				}
			}
		});

		this.$typeahead.on('typeahead:select', (ev, suggestion) => {
			this.model.set(this.options.bindingProperty, suggestion);
		});

		this.listenTo(model, `validationError:${this.options.bindingProperty}`, (value) => {
			if (value != null) {
				this.$el.addClass('validation-error');
			}
		});

		this.listenTo(model, `change:${this.options.bindingProperty}`, (__model, item) => {
			this.$typeahead.typeahead('val', (item || {}).caption || item);
		});

		if (_.isObject(model.get(this.options.bindingProperty))) {
			this.$typeahead.typeahead('val', model.get(this.options.bindingProperty).caption);
		}

		this.$('.b-input__remove').on('click', (e) => {
			e.stopPropagation();
			if (model === e) return;
			this.removeItem(model);
		});
	},

	removeItem(model) {
		model.set(this.options.bindingProperty, null);
	},

}, {
	dictionaryToCollection(data) {
		return new AutocompleteCollection(data);
	},

	arrayToCollection(data) {
		return Autocomplete.dictionaryToCollection(data);
	},

	storeCollection(collection) {
		if (!Autocomplete.stores) {
			Autocomplete.stores = {};
		}
		if (!Autocomplete.stores[collection.cid]) {
			Autocomplete.stores[collection.cid] = collection;
		}
		return collection.cid;
	},

	getStoreCollection(cid) {
		return Autocomplete.stores[cid];
	},
});

export default Autocomplete;
